/**
 * PaywallModal — minimal call-to-action that punts the user to the new
 * Konto-based billing page (/settings/billing). The old Konto v0 3DS
 * widget has been retired (Safari CSP bug). Triggered by 403
 * `paywall_required` responses via window.__triggerPaywall.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/contexts/I18nContext';
import { X, CreditCard, ArrowRight } from 'lucide-react';

const T = {
  is: {
    title: 'Áskrift krafist',
    body: 'Veldu pakka til að halda áfram að nota Rektra.',
    cta: 'Velja áskrift',
    later: 'Loka',
  },
  en: {
    title: 'Subscription required',
    body: 'Choose a plan to keep using Rektra.',
    cta: 'Choose a plan',
    later: 'Close',
  },
};

const PaywallModal = ({ open, onClose }) => {
  const navigate = useNavigate();
  const { lang } = useI18n();
  const t = T[lang] || T.en;

  if (!open) return null;

  const goBilling = () => {
    onClose && onClose();
    navigate('/settings/billing');
  };

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-background/85 backdrop-blur-sm px-4"
      data-testid="paywall-modal"
      onClick={onClose}
    >
      <div
        className="card border border-accent/30 max-w-sm w-full p-6 sm:p-7 space-y-5 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-foreground-muted hover:text-foreground"
          data-testid="paywall-modal-close"
          aria-label="close"
        >
          <X size={18} />
        </button>
        <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center">
          <CreditCard className="text-accent" size={22} />
        </div>
        <div>
          <h2 className="text-lg font-semibold mb-1">{t.title}</h2>
          <p className="text-sm text-foreground-muted leading-relaxed">{t.body}</p>
        </div>
        <button
          onClick={goBilling}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-accent text-background font-semibold text-sm hover:bg-accent/90 transition-colors"
          data-testid="paywall-modal-cta"
        >
          {t.cta}
          <ArrowRight size={16} />
        </button>
        <button
          onClick={onClose}
          className="w-full text-xs text-foreground-muted hover:text-foreground"
          data-testid="paywall-modal-later"
        >
          {t.later}
        </button>
      </div>
    </div>
  );
};

export default PaywallModal;
